import { Box, BoxProps, SystemStyleObject } from "@chakra-ui/react";
import { useGetTransparency } from "utils/colorHooks";

export type ScrollContainerProps = BoxProps & {
  isEmptyContentCentered?: boolean;
  isNoBackground?: boolean;
};

export default function ScrollContainer({
  children,
  isEmptyContentCentered = true,
  isNoBackground = false,
  ...rest
}: ScrollContainerProps) {
  const getTransparency = useGetTransparency();

  return (
    <Box
      overflow="auto"
      height="100%"
      position="relative"
      backgroundColor={
        isNoBackground ? undefined : getTransparency("gray.100", 0.25)
      }
      {...rest}
      sx={{
        ...rest.sx,
        table: {
          ...(rest.sx?.["table" as keyof SystemStyleObject] as
            | SystemStyleObject
            | undefined),
          backgroundColor: isNoBackground ? undefined : "white",
        },
        ".scroll-container-centered": isEmptyContentCentered
          ? {
              position: "absolute",
              left: 0,
              top: "calc(50% + 1.5rem)",
              transform: "translateY(-50%)",
              background: "none",
              width: "100%",
            }
          : {},
      }}
    >
      {children}
    </Box>
  );
}
